import  { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, CircularProgress, Container, Paper } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../features/counter/Authslice.js';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';


const AuthSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const processToken = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const token = query.get('token');

        if (!token) {
          throw new Error('No authentication token found');
        }

       
        localStorage.setItem('accessToken', token);
        
       
        const decodedToken = jwtDecode(token);
        const user = {
          id: decodedToken.id,
          email: decodedToken.email,
          role: decodedToken.role,
          username: decodedToken.username || null
        };

       
        dispatch(
          setCredentials({
            token,
            user,
            isAuthenticated: true,
          })
        );

        
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        
        const roleRoutes = {
          admin: "/superadmin",
          ca: "/Cadashboard",
          cs: "/csdashboard",
          user: "/dashboard"
        };

        const targetRoute = roleRoutes[user.role] || "/KycManagement";
        
        
        setTimeout(() => {
          navigate(targetRoute);
        }, 1500);
        
      } catch (error) {
        console.error('Error processing authentication:', error);
        navigate('/login', { state: { error: 'Authentication failed. Please try again.' } });
      }
    };

    processToken();
  }, [dispatch, location.search, navigate]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <CircularProgress size={60} sx={{ mb: 3, color: '#EB5A3C' }} />
        <Typography variant="h5" gutterBottom>
          Authentication Successful
        </Typography>
        <Typography variant="body1" color="textSecondary">
          You've successfully logged in! Redirecting you to your dashboard...
        </Typography>
      </Paper>
    </Container>
  );
};

export default AuthSuccess;